import { useEffect } from "react"
import { options } from "../utils/tmdbToken"
import { useDispatch, useSelector } from "react-redux"
import { addUpcoming } from "../utils/movieSlice"

const useUpcoming=()=>{
    const dispatch=useDispatch()
    const upcomingmovies=useSelector(store=>store.movie.upcoming)
    const fetchUpcoming=async()=>{
            const data=await fetch("https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1",options)
            const json=await data.json()
            dispatch(addUpcoming(json.results))
    }
    useEffect(()=>{
       !upcomingmovies&& fetchUpcoming()
    },[])
}
export default useUpcoming